import React, { useState } from "react";
import { Box, Typography, Paper, TextField, Button, CircularProgress, Alert, Link } from "@mui/material";
import { useQueryBrand } from "./hooks";

export default function BrandQuerySection({ brandId }) {
  const [prompt, setPrompt] = useState("");
  const [result, setResult] = useState(null);
  const queryBrand = useQueryBrand(brandId);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!prompt.trim()) {
      return;
    }

    try {
      const response = await queryBrand.mutateAsync(prompt);
      setResult(response);
    } catch (error) {
      setResult({
        answer: `Error: ${error.message}`,
        sources: []
      });
    }
  };

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Query LLM Using Brand Scraped Data
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Enter your question about this brand..."
          disabled={queryBrand.isLoading}
          sx={{ mb: 2 }}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={!prompt.trim() || queryBrand.isLoading}
          sx={{ mb: 2 }}
        >
          {queryBrand.isLoading
            ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1, color: "inherit" }} />
              Processing...
              </>
            )
            : (
              "Ask LLM"
            )}
        </Button>
      </Box>

      {result && (
        <Box mt={2}>
          {result.answer.startsWith("Error:")
            ? (
              <Alert severity="error">{result.answer}</Alert>
            )
            : (
              <>
                <Typography variant="body1" paragraph>
                  {result.answer}
                </Typography>

                {result.sources.length > 0 && (
                  <Box mt={2}>
                    <Typography variant="subtitle2" gutterBottom>
                    Sources:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, m: 0 }}>
                      {result.sources.map((source, index) => (
                        <li key={index}>
                          <Link href={source} target="_blank" rel="noopener noreferrer">
                            {source}
                          </Link>
                        </li>
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            )}
        </Box>
      )}
    </Paper>
  );
}
